<!-- Tax Liability Dashboard Component -->
<!-- Handles two modes: Change Status and Tax Liability Amount -->

<!-- Modal Header - Different titles based on mode -->
@if (modal_name) {
<div class="modal-header">
  <h3 class="modal-title">
    <!-- Change Status Mode Title -->
    @if (modal_name === 'changeStatusTlc') {
<span>{{modalTitle}}</span>
}
    <!-- Tax Liability Amount Mode Title -->
    @if (modal_name !== 'changeStatusTlc') {
<span>{{title}} - {{rowData.LEID}}</span>
}
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
}

<!-- Change Status Mode -->
@if (modal_name === 'changeStatusTlc') {
<div>
  <div class="modal-body change-status-modal-body" [hidden]="minimise">
    <div class="main-hdr-bg">
      &nbsp;&nbsp;<b>Key:</b>&nbsp;<div class="key-display">LEID - CDR</div>
    </div>

    @if (entities && entities.length < 10) {
<div class="entitie-holder">
      @for (entity of entities; track $index; let i = $index) {
<div class="btn-group dropup pull-left">
        <button type="button" class="btn btn-xs btn-default">{{ entity.data?.LEID || entity.LEID }} - {{
          entity.data?.TAX_CODE || entity.TAX_CODE }}</button>
        <button type="button" (click)="removeEntity(i)" class="btn btn-xs btn-danger dropdown-toggle"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="fa fa-times"></span>
        </button>
      </div>
}
    </div>
}

    @if (entities && entities.length > 10) {
<div class="entitie-holder">
      <div>
        <label>Selected Entities Count: <span class="badge badge-pill badge-info">{{entities.length}}</span></label>
      </div>
    </div>
}

    <div class="top-alignment"></div>

    <div class="row form-group">
      <div class="col-md-6">
        <b class="status-label-text">&emsp;&emsp;&emsp;</b>Open
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <label>
              <input type="radio" name="unBlocked" value="Open" [(ngModel)]="radioUnblk"
                (change)="changeStatus(radioUnblk)" />
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-md-6">
        <b class="status-label-text">&emsp;&emsp;&emsp;</b>Close
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <label>
              <input type="radio" name="unBlocked" value="Closed" [(ngModel)]="radioUnblk"
                (change)="changeStatus(radioUnblk)" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (modal_name) {
<div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" [disabled]="isSaveClicked" (click)="saveStatus()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    @if (modal_name != null) {
<button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
}
  </div>
}
</div>
}

<!-- Tax Liability Amount Mode -->
@if (modal_name !== 'changeStatusTlc') {
<div class="tax-liability-content-wrapper">
  @if (dataLoading) {
<div align="center" class="gt-filter-loading">
    <i class="fa fa-spinner fa-spin loading-spinner-icon"></i>
  </div>
}

  @if (!dataLoading) {
<div class="modal-body" [hidden]="minimise">
    <!-- Currency Selector Section -->
    <div class="currency-selector-section">
      <div class="currency-dropdown-container">
        <!-- <label class="currency-label">Reporting Currency:</label> -->
        <select class="form-control selectpicker currency-dropdown" [(ngModel)]="selectedGroup"
          (ngModelChange)="updated(selectedGroup?.CURR_CODE)" [disabled]="currOverrideFlag == 'Y'">
          <option [ngValue]="null">Select Reporting Currency</option>
          @for (currency of currencies; track $index) {
<option [ngValue]="currency">
            {{ currency.CURR_CODE }} - {{ currency.CURR_DESC }}
          </option>
}
        </select>
        @if (flag1) {
<span class="form-error-container">Reporting Currency is a required field.</span>
}
      </div>
    </div>

    <!-- Form Entry Table with Red Header -->
    <div class="form-entry-table-container">
      <table class="table table-bordered text custom-table tax-liability-table">
        <thead>
          <tr class="table-header-red">
            <th>FTR Attribute</th>
            <th>FTR Description</th>
            <th>FTR Relates To</th>
            <th class="date-provided-header">Description of Date<br>Provided</th>
            <th>{{selectedGroup?.CURR_CODE || 'Amount'}} Amount</th>
            @if (statusFlag) {
<th>Type of Adjustment</th>
}
            <th>Date</th>
            <th>Enter Tax Return Line</th>
            <th>Entered by</th>
            <th>Entered on</th>
          </tr>
        </thead>
        <tbody>
          @for (obj of objects; track $index; let i = $index) {
<tr>
            <td width="10%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <select class="form-control selectpicker" [(ngModel)]="obj.descriptionDesc"
                  (ngModelChange)="changeDescriptionLaws(obj.descriptionDesc, i)">
                  <option [ngValue]="null">Select Description</option>
                  @for (desc of description; track $index) {
<option [ngValue]="desc">{{ desc.CODE_DESC }}</option>
}
                </select>
                @if (obj.descFlag) {
<span class="form-error-container">Please select type of description</span>
}
              </div>
            </td>
            <td width="10%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <input type="text" id="FTRDescription" name="FTRDescription" [(ngModel)]="obj.ftrDescription"
                  class="form-control input-sm">
              </div>
            </td>
            <td width="12%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <select class="form-control selectpicker" [(ngModel)]="obj.ftrRelatesToDesc"
                  (ngModelChange)="changeFTRDescription(obj.ftrRelatesToDesc, i)">
                  <option [ngValue]="null">Select FTR Relates To</option>
                  @for (desc of ftrRelatesToList; track $index) {
<option [ngValue]="desc">{{ desc.CODE_DESC }}</option>
}
                </select>
                @if (obj.ftrRelatestodescFlag) {
<span class="form-error-container">Please select FTR Relates To
                  description</span>
}
              </div>
            </td>
            <td width="12%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <select class="form-control selectpicker" [(ngModel)]="obj.descriptionDateProvidedDesc"
                  (ngModelChange)="changeDateProvidedDescription(obj.descriptionDateProvidedDesc, i)">
                  <option [ngValue]="null">Select Description of Date Provided</option>
                  @for (desc of descriptionDateProvided; track $index) {
<option [ngValue]="desc">{{ desc.CODE_DESC }}</option>
}
                </select>
                @if (obj.descriptionDateProvidedFlag) {
<span class="form-error-container">Please select type of
                  description</span>
}
              </div>
            </td>
            <td width="10%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <input type="text" id="TaxesAmount" name="TaxesAmount" [(ngModel)]="obj.taxesAmount" onlyIntegersWithLength
                  class="text-right form-control input-sm numText">
              </div>
            </td>
            @if (statusFlag) {
<td width="12%" class="table-cell-aligned">
              <div class="form-field-wrapper">
                <select class="form-control selectpicker" [(ngModel)]="obj.adjustmentDesc"
                  (ngModelChange)="changeAdjustmentLaws(obj.adjustmentDesc, i)">
                  <option [ngValue]="null">Select Type of Adjustment</option>
                  @for (adjs of adjustment; track $index) {
<option [ngValue]="adjs">{{ adjs.CODE_DESC }}</option>
}
                </select>
                @if (obj.adjustFlag) {
<span class="form-error-container">Please select type of Adjustment</span>
}
              </div>
            </td>
}
            <td width="12%" class="table-cell-aligned">
              <div class="form-field-wrapper tlc-date-field">
                <ap-field [datepicker]="true"
                  [title]="''"
                  [hideTitleOnInput]="true"
                  [editable]="false"
                  [dpAutoClose]="true"
                  [dpType]="'single'"
                  [dpRange]="false"
                  [dpDateformat]="'MM/dd/yyyy'"
                  [dpSelectedDates]="obj.dateFiledDates"
                  (dpSelectedDatesChange)="onAppkitDateChangeForFirstTable(obj, i, $event)"
                  class="tlc-date-picker not-disabled">
                  <input appkit-field aria-label="Date Filed, Paid, or Refunded" placeholder="MM/DD/YYYY" />
                </ap-field>
                @if (obj.dateFlag) {
<span class="form-error-container">Please select Date Filed, Paid, or
                  Refunded</span>
}
                @if (obj.invalidDateFlag) {
<span class="form-error-container">Date entered should be more than two
                  years from tax year</span>
}
                @if (obj.invalidDateOpenFlag) {
<span class="form-error-container">Date entered should be current tax
                  year and beyond tax year</span>
}
              </div>
            </td>
            <td class="table-cell-aligned">
              <div class="form-field-wrapper">
                <textarea cols="10" rows="3" maxlength="4000" wrap="hard" name="usrcomments" class="form-control"
                  [(ngModel)]="obj.usrcomments"></textarea>
              </div>
            </td>
            <td class="table-cell-aligned">
              <div class="form-field-wrapper text-display">{{obj.userUpdate}}</div>
            </td>
            <td class="table-cell-aligned">
              <div class="form-field-wrapper text-display">{{obj.dateUpdate}}</div>
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Add New Button - After first table, before Existing Records Table -->
    @if (modal_name !== 'changeStatusTlc' && modal_name && !dataLoading) {
<div class="add-new-button-container" [hidden]="minimise"
     >
      <button class="save-button add-new-button" type="button" (click)="addNew({})">Add New
      </button>
    </div>
}

    <!-- Existing Records Table -->
    @if (!disableTable && modal_name !== 'changeStatusTlc') {
<table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table"
     >
      <thead>
        <tr>
          <th>Description</th>
          <th>Currency</th>
          <th>FTR Description</th>
          <th>FTR Relates to</th>
          <th>Description of Date provided</th>
          <th>Amount</th>
          @if (statusFlag) {
<th>Type of Adjustment</th>
}
          <th>Date Filed</th>
          <th>Comments</th>
          <th>Entered by</th>
          <th>Entered on</th>
          <th>Action</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for (record of filteredRecords; track $index; let i = $index) {
<tr>
          <td>
            @if (record.TYPE == 'STANDALONE') {
<div class="col-md-12">
              <select class="form-control selectpicker" [(ngModel)]="record.DESCRIPTION" [disabled]="record.EDIT_FLAG">
                <option [value]="null">Select Description</option>
                @for (desc of description; track $index) {
<option [value]="desc.CODE_DESC">{{desc.CODE_DESC}}</option>
}
              </select>
            </div>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.DESCRIPTION}}</div>
}
          </td>
          <td>{{record.CURRENCY}}</td>
          <td>
            @if (record.TYPE == 'STANDALONE') {
<textarea cols="10" maxlength="4000" wrap="hard" name="ftrComments" class="form-control"
              [(ngModel)]="record.FTRDESCRIPTION" [disabled]="record.EDIT_FLAG"
             ></textarea>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.FTRDESCRIPTION}}</div>
}
          </td>
          <td>
            @if (record.TYPE == 'STANDALONE') {
<div class="col-md-12">
              <select class="form-control selectpicker" [(ngModel)]="record.FTRRELATESTODESC"
                [disabled]="record.EDIT_FLAG">
                <option [value]="null">Select FTR Relates To</option>
                @for (desc of ftrRelatesToList; track $index) {
<option [value]="desc.CODE_DESC">{{desc.CODE_DESC}}</option>
}
              </select>
            </div>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.FTRRELATESTODESC}}</div>
}
          </td>
          <td>
            @if (record.TYPE == 'STANDALONE') {
<div class="col-md-12">
              <select class="form-control selectpicker" [(ngModel)]="record.DESCRIPTIONDATEPROVIDEDDESC"
                [disabled]="record.EDIT_FLAG">
                <option [value]="null">Select Description of Date Provided</option>
                @for (desc of descriptionDateProvided; track $index) {
<option [value]="desc.CODE_DESC">{{desc.CODE_DESC}}
                </option>
}
              </select>
            </div>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.DESCRIPTIONDATEPROVIDEDDESC}}</div>
}
          </td>
          <td align="right">
            @if (record.TYPE == 'STANDALONE') {
<input type="text" id="TaxesAmt" name="TaxesAmt" [disabled]="record.EDIT_FLAG" [(ngModel)]="record.FC_AMT" onlyIntegersWithLength
              class="text-right form-control input-sm numText">
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.FC_AMT}}</div>
}
          </td>
          @if (statusFlag) {
<td>
            @if (record.TYPE == 'STANDALONE') {
<div class="col-md-12">
              <select class="form-control selectpicker" [(ngModel)]="record.ADJUSTMENT" [disabled]="record.EDIT_FLAG">
                <option [value]="null">Select Type of Adjustment</option>
                @for (adjs of adjustment; track $index) {
<option [value]="adjs.CODE_DESC">{{adjs.CODE_DESC}}</option>
}
              </select>
            </div>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.ADJUSTMENT}}</div>
}
          </td>
}
          <td width="15%" class="table-cell-aligned">
            @if (record.TYPE == 'STANDALONE') {
<div class="form-field-wrapper tlc-date-field">
              <ap-field [datepicker]="true"
                [title]="''"
                [hideTitleOnInput]="true"
                [editable]="false"
                [dpAutoClose]="true"
                [dpType]="'single'"
                [dpRange]="false"
                [dpDateformat]="'MM/dd/yyyy'"
                [disabled]="record.EDIT_FLAG"
                [dpSelectedDates]="record.transDateDates"
                (dpSelectedDatesChange)="onAppkitDateChange(record, i, $event)"
                class="tlc-date-picker"
                [ngClass]="{'not-disabled': !record.EDIT_FLAG}">
                <input appkit-field aria-label="Date Filed" placeholder="MM/DD/YYYY" />
              </ap-field>
            </div>
}
            @if (record.TYPE == 'GROUP') {
<div class="date-display">
              {{record.TRANS_DATE | date:'MM/dd/yyyy'}}
            </div>
}
          </td>
          <td>
            @if (record.TYPE == 'STANDALONE') {
<textarea cols="10" maxlength="4000" wrap="hard" name="usercomments" class="form-control"
              [(ngModel)]="record.DETAIL_COMMENTS" [disabled]="record.EDIT_FLAG"
             ></textarea>
}
            @if (record.TYPE == 'GROUP') {
<div>{{record.DETAIL_COMMENTS}}</div>
}
          </td>
          <td>{{record.UPDATED_BY}}</td>
          <td>{{record.UPDATED_ON?.substring(0,10)}}</td>
          <td>
            <button class="btn btn-xs btn-danger fa fa-times deleteBtn" type="button"
              (click)="singleRowDelete(record, true, i)" [disabled]="record.EDIT_FLAG == false">&nbsp; Delete</button>
          </td>
          @if (record.TYPE == 'STANDALONE') {
<td align="center">
            <a href="javascript:void(0)" (click)="editLiab(record, true, i)">
              <i class="fa fa-pencil"></i> Edit
            </a>
          </td>
}
        </tr>
}
      </tbody>
    </table>
}

    <!-- Totals Table -->
    @if (!disableTable && modal_name !== 'changeStatusTlc') {
<table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table"
     >
      <thead>
        <tr>
          <th>Totals</th>
          <th>Currency</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        @for (totalrecord of filteredTotalRecords; track $index) {
<tr>
          <td>{{totalrecord.DESCRIPTION}}</td>
          <td>{{totalrecord.CURRENCY}}</td>
          <td align="right">{{totalrecord.AMOUNT | number}}</td>
        </tr>
}
      </tbody>
    </table>
}
  </div>
}

  <!-- Footer with Save/Reset/Cancel on Right -->
  @if (modal_name !== 'changeStatusTlc' && modal_name) {
<div class="modal-footer" [hidden]="minimise">
    <div class="footer-buttons-right">
      <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="singleRowSave()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
      </button>
      <button class="reset-button" type="button" (click)="reset()">Reset</button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
}
</div>
}

<!-- Confirmation Dialog using shared confirmation modal (matches admin pattern) -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="modalConfig"
      [visible]="false"
      (confirmed)="hasPendingDelete ? onConfirmDelete() : onConfirmEdit()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}